import { render, staticRenderFns } from "./cdcbTable.vue?vue&type=template&id=0b8bac7d&scoped=true"
import script from "./cdcbTable.vue?vue&type=script&lang=js"
export * from "./cdcbTable.vue?vue&type=script&lang=js"
import style0 from "./cdcbTable.vue?vue&type=style&index=0&id=0b8bac7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8bac7d",
  null
  
)

export default component.exports